import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';
import { SpiderAccount, SpiderSchedule } from '../_models';

@Injectable({ providedIn: 'root' })
export class SpiderService {
    constructor(private http: HttpClient) { }

    getAllSpiderAccount(): Observable<BaseResponse> {
      return this.http.get(`${environment.apiUrl}/spider/accounts`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addAccount(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/spider/account/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateAccount(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/spider/account/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteAccount(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/spider/account/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAccount(id: any): Observable<SpiderAccount> { //detail
      return this.http.get(`${environment.apiUrl}/spider/account/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new SpiderAccount().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    listAccounts(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/spider/account/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, SpiderAccount);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }


    saveSchedule(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/spider/schedule/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    restartSchedule(id: any): Observable<BaseResponse> {
      return this.http.put(`${environment.apiUrl}/spider/schedule/restart/${id}`, {})
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    restartAllSchedule(): Observable<BaseResponse> {
      return this.http.put(`${environment.apiUrl}/spider/schedule/restart-all`, {})
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteSchedule(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/spider/schedule/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    listSchedules(filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/spider/schedule/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, SpiderSchedule);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

}
